<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  show: { type: Boolean, default: false },
  message: { type: String, default: 'Publishing fixture...' }
})

const emit = defineEmits(['close'])

const handleBackdropClick = (e) => {
  if (e.target === e.currentTarget) emit('close')
}
</script>

<template>
  <transition
    enter-active-class="transition duration-200 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition duration-150 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="show"
      class="fixed inset-0 z-[1100] bg-black/50 flex items-center justify-center p-6"
      @click="handleBackdropClick"
    >
      <div
        class="bg-white dark:bg-gray-900 rounded-xl shadow-2xl w-full max-w-sm p-6 text-center border border-gray-100 dark:border-gray-800"
        role="dialog"
        aria-live="polite"
      >
        <div class="mx-auto h-14 w-14 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center mb-4">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 dark:border-blue-400"></div>
        </div>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">
          Publishing
        </h3>
        <p class="text-gray-600 dark:text-gray-300">
          {{ message }}
        </p>
        <div class="mt-4">
          <div class="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
            <div class="bg-blue-600 dark:bg-blue-400 h-2 rounded-full animate-pulse" style="width: 60%"></div>
          </div>
        </div>
        <button
          type="button"
          class="mt-5 inline-flex items-center justify-center px-4 py-2 rounded-md bg-gray-600 text-white text-sm font-medium hover:bg-gray-700 focus:outline-none"
          @click="$emit('close')"
        >
          Cancel
        </button>
      </div>
    </div>
  </transition>
</template>

<style scoped>
</style>
